import type { LinkSearchListItemData } from '@atlaskit/link-picker/types';

import { type QuickSearchResult } from './types';
import { getIconFromContentType } from './ui';

export const mapSearchProviderResultToLinkSearchItemData = ({
	objectId,
	container,
	title,
	contentType,
	url,
	updatedTimestamp,
	iconUrl,
	subtype,
}: QuickSearchResult): LinkSearchListItemData => ({
	objectId,
	name: title,
	container,
	url,
	...// Use the icon url from the quick search result if it exists but still resolve the altText,
	// which return defaultAlt if no icon is found. Otherwise find an icon by looking up the content type
	(iconUrl
		? {
				icon: iconUrl,
				iconAlt: getIconFromContentType(contentType, subtype).iconAlt,
			}
		: getIconFromContentType(contentType, subtype)),
	lastUpdatedDate: updatedTimestamp ? new Date(updatedTimestamp) : undefined,
	prefetch: false,
	meta: {
		source: 'xp-search',
	},
});
